import { toast } from "react-hot-toast";
import httpRequest from "../axios/index";
import { CHATS } from "../constants/apiEndPoints";

export const ReadAllMessages = async () => {
  try {
    await httpRequest.patch(`${CHATS}/all`);
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message || "Something went wrong";
    toast.error(errorMessage);
  }
};
